/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '@angular/common';
import * as import4 from './location-search-panel.component';
import * as import5 from '@angular/forms';
import * as import6 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import7 from '../../ui-elements/icon/icon.component';
import * as import8 from '../../notification/notification.service';
const styles_LocationSearchPanelComponent:any[] = ([] as any[]);
export const RenderType_LocationSearchPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_LocationSearchPanelComponent,
  data: {}
}
);
function View_LocationSearchPanelComponent_1(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'shroud'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.hideSelection($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
  },(null as any),(null as any)))],(null as any),(null as any));
}
function View_LocationSearchPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'location-search-entry-placeholder'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.message.location-search.placeholder'));
    ck(v,1,0,currVal_0);
  });
}
function View_LocationSearchPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'location-search-results-result'
      ]
      ],[[
        8,
        'id',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectLocation(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'prediction-',v.context.index,'');
    ck(v,0,0,currVal_0);
    const currVal_1:any = v.context.$implicit.description;
    ck(v,1,0,currVal_1);
  });
}
function View_LocationSearchPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'location-search-results'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LocationSearchPanelComponent_4)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'location-search-results-copyright'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'src',
        'assets/images/powered_by_google_on_white.png'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.predictions;
    ck(v,3,0,currVal_0);
  },(null as any));
}
export function View_LocationSearchPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LocationSearchPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'location-search'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'location-search-entry'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'input',[
      [
        'class',
        'location-search-entry-input'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'click'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.LocationSearchPanelComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,8)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,8).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,8)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,8)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.searchText = $event)) !== false);
        ad = (pd_4 && ad);
      }
      if (('click' === en)) {
        const pd_5:any = ((<any>(co.selectionHidden = false)) !== false);
        ad = (pd_5 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import5.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import5.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import5.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import5.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import5.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import5.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import5.NgControl,(null as any),[import5.NgModel]),
    import0.ɵdid(16384,(null as any),0,import5.NgControlStatus,[import5.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LocationSearchPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'location-search-entry-icon'
      ]
    ],(null as any),(null as any),(null as any),import6.View_IconComponent_0,import6.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import7.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LocationSearchPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.LocationSearchPanelComponent = v.component;
    const currVal_0:boolean = (!co.selectionHidden && co.predictions.length);
    ck(v,1,0,currVal_0);
    const currVal_8:any = co.searchText;
    ck(v,10,0,currVal_8);
    const currVal_9:boolean = !co.searchText;
    ck(v,15,0,currVal_9);
    const currVal_10:any = 'search';
    ck(v,18,0,currVal_10);
    const currVal_11:boolean = (!co.selectionHidden && co.predictions.length);
    ck(v,22,0,currVal_11);
  },(ck,v) => {
    const currVal_1:any = import0.ɵnov(v,12).ngClassUntouched;
    const currVal_2:any = import0.ɵnov(v,12).ngClassTouched;
    const currVal_3:any = import0.ɵnov(v,12).ngClassPristine;
    const currVal_4:any = import0.ɵnov(v,12).ngClassDirty;
    const currVal_5:any = import0.ɵnov(v,12).ngClassValid;
    const currVal_6:any = import0.ɵnov(v,12).ngClassInvalid;
    const currVal_7:any = import0.ɵnov(v,12).ngClassPending;
    ck(v,7,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_LocationSearchPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-location-search-panel',([] as any[]),(null as any),(null as any),(null as any),View_LocationSearchPanelComponent_0,RenderType_LocationSearchPanelComponent)),
    import0.ɵdid(114688,(null as any),0,import4.LocationSearchPanelComponent,[
      import0.NgZone,
      import8.NotificationService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const LocationSearchPanelComponentNgFactory:import0.ComponentFactory<import4.LocationSearchPanelComponent> = import0.ɵccf('woa-location-search-panel',import4.LocationSearchPanelComponent,View_LocationSearchPanelComponent_Host_0,{
  accuracy: 'accuracy',
  latitude: 'latitude',
  longitude: 'longitude'
}
,{onSelect: 'onSelect'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXJpbmctY29udGV4dC9sb2NhdGlvbi1zZWFyY2gtcGFuZWwvbG9jYXRpb24tc2VhcmNoLXBhbmVsLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL29yZGVyaW5nLWNvbnRleHQvbG9jYXRpb24tc2VhcmNoLXBhbmVsL2xvY2F0aW9uLXNlYXJjaC1wYW5lbC5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL29yZGVyaW5nLWNvbnRleHQvbG9jYXRpb24tc2VhcmNoLXBhbmVsL2xvY2F0aW9uLXNlYXJjaC1wYW5lbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXJpbmctY29udGV4dC9sb2NhdGlvbi1zZWFyY2gtcGFuZWwvbG9jYXRpb24tc2VhcmNoLXBhbmVsLmNvbXBvbmVudC50cy5Mb2NhdGlvblNlYXJjaFBhbmVsQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cInNocm91ZFwiICpuZ0lmPVwiIXNlbGVjdGlvbkhpZGRlbiAmJiBwcmVkaWN0aW9ucy5sZW5ndGhcIiAoY2xpY2spPVwiaGlkZVNlbGVjdGlvbigkZXZlbnQpXCI+PC9kaXY+XG48ZGl2IGNsYXNzPVwibG9jYXRpb24tc2VhcmNoXCI+XG4gICAgPGRpdiBjbGFzcz1cImxvY2F0aW9uLXNlYXJjaC1lbnRyeVwiPlxuICAgICAgICA8aW5wdXQgY2xhc3M9XCJsb2NhdGlvbi1zZWFyY2gtZW50cnktaW5wdXRcIiB0eXBlPVwidGV4dFwiIFsobmdNb2RlbCldPVwic2VhcmNoVGV4dFwiIChjbGljayk9XCJzZWxlY3Rpb25IaWRkZW4gPSBmYWxzZVwiPlxuICAgICAgICA8ZGl2ICpuZ0lmPVwiIXNlYXJjaFRleHRcIiBjbGFzcz1cImxvY2F0aW9uLXNlYXJjaC1lbnRyeS1wbGFjZWhvbGRlclwiPlxuICAgICAgICAgICAge3snd29hLm1lc3NhZ2UubG9jYXRpb24tc2VhcmNoLnBsYWNlaG9sZGVyJyB8IHRyYW5zbGF0ZX19XG4gICAgICAgIDwvZGl2PlxuICAgICAgICA8d29hLWljb24gY2xhc3M9XCJsb2NhdGlvbi1zZWFyY2gtZW50cnktaWNvblwiIFtuYW1lXT1cIidzZWFyY2gnXCI+PC93b2EtaWNvbj5cbiAgICA8L2Rpdj5cbiAgICA8ZGl2ICpuZ0lmPVwiIXNlbGVjdGlvbkhpZGRlbiAmJiBwcmVkaWN0aW9ucy5sZW5ndGhcIiBjbGFzcz1cImxvY2F0aW9uLXNlYXJjaC1yZXN1bHRzXCI+XG4gICAgICAgIDxkaXYgKm5nRm9yPVwibGV0IHByZWRpY3Rpb24gb2YgcHJlZGljdGlvbnM7IGxldCBpID0gaW5kZXhcIiBjbGFzcz1cImxvY2F0aW9uLXNlYXJjaC1yZXN1bHRzLXJlc3VsdFwiXG4gICAgICAgICAgICAgaWQ9XCJwcmVkaWN0aW9uLXt7aX19XCIgKGNsaWNrKT1cInNlbGVjdExvY2F0aW9uKHByZWRpY3Rpb24pXCI+XG4gICAgICAgICAgICB7e3ByZWRpY3Rpb24uZGVzY3JpcHRpb259fVxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdiBjbGFzcz1cImxvY2F0aW9uLXNlYXJjaC1yZXN1bHRzLWNvcHlyaWdodFwiPlxuICAgICAgICAgICAgPCEtLXN1cHByZXNzIEh0bWxVbmtub3duVGFyZ2V0LCBIdG1sVW5rbm93blRhcmdldCAtLT5cbiAgICAgICAgICAgIDxpbWcgc3JjPVwiYXNzZXRzL2ltYWdlcy9wb3dlcmVkX2J5X2dvb2dsZV9vbl93aGl0ZS5wbmdcIi8+XG4gICAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuPC9kaXY+XG4iLCI8d29hLWxvY2F0aW9uLXNlYXJjaC1wYW5lbD48L3dvYS1sb2NhdGlvbi1zZWFyY2gtcGFuZWw+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs2QkNBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQW1FO1FBQUE7UUFBQTtNQUFBO01BQW5FO0VBQUE7Ozs7TUFJUTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1FO01BQUE7TUFBQTtJQUFBO0lBQUE7Z0JBQUE7OztJQUFBO0lBQUE7OztJQUFBO0lBQUE7Ozs7O01BTW5FO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQzJCO1FBQUE7UUFBQTtNQUFBO01BRDNCO0lBQUE7SUFDZ0U7TUFBQTtNQUFBO0lBQUE7SUFBQTs7O0lBQTNEO0lBREwsU0FDSyxTQURMO0lBQ2dFO0lBQUE7Ozs7O01BRnBFO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBb0Y7SUFDaEY7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHTTtNQUNOO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBK0M7SUFDVTtNQUNyRDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlEO0lBQ3ZEOzs7O0lBUEQ7SUFBTCxTQUFLLFNBQUw7Ozs7O0lBVlI7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF5RztNQUN6RztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTZCO01BQ3pCO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBbUM7SUFDL0I7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUF1RDtRQUFBO1FBQUE7TUFBQTtNQUF5QjtRQUFBO1FBQUE7TUFBQTtNQUFoRjtJQUFBO2dCQUFBOzs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7Z0JBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7Z0JBQUE7SUFBa0g7SUFDbEg7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUVNO01BQ047UUFBQTtRQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTBFO0lBQ3hFO0lBQ047Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQVNNO0lBQ0o7Ozs7SUFuQmM7SUFBcEIsU0FBb0IsU0FBcEI7SUFHK0Q7SUFBdkQsVUFBdUQsU0FBdkQ7SUFDSztJQUFMLFVBQUssU0FBTDtJQUc2QztJQUE3QyxVQUE2QyxVQUE3QztJQUVDO0lBQUwsVUFBSyxVQUFMOztJQU5JO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsU0FBQSxxRUFBQTs7Ozs7SUNIUjtnQkFBQTs7O0lBQUE7S0FBQTs7O0lBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/app/ordering-context/location-search-panel/location-search-panel.component.ngfactory.ts